import { render, staticRenderFns } from "./LlNormalPopup.vue?vue&type=template&id=8c4a1c36"
import script from "./LlNormalPopup.vue?vue&type=script&lang=js"
export * from "./LlNormalPopup.vue?vue&type=script&lang=js"
import style0 from "./LlNormalPopup.vue?vue&type=style&index=0&id=8c4a1c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports